import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 03ED4E2F-41CE-47D7-ABB4-C8515C202499
 * name garage-alert
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/garage-alert.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 */
export const GarageAlertIcon = createSvgIcon(<><path d="M17,20H15V11H5V20H3V9L10,5L17,9V20M6,12H14V14H6V12M6,15H14V17H6V15M19,15V10H21V15H19M19,19V17H21V19H19Z" /></>, 'GarageAlertIcon');
export default GarageAlertIcon